/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PartnerRequestPage = lazyLoad(
  () => import('./index'),
  module => module.PartnerRequestPage
);
